export default __webpack_public_path__ + "static/media/middleImage_2_below.5d6e4f23.png";